import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getExceptionsBySearch,
  setTelemetryDeviceType,
  setTelemetryImageType,
  setTelemetrySearchTerm,
  setTelemetryDate
} from './../actions';
import {
  getExceptionsByTerm,
  getAcquireSearchTerm,
  getAcquireDeviceType,
  getAcquireImageType,
  getAcquireDate
} from './../reducers';

import AcquisitionTelemetrySelectorComponent
  from './../Components/AcquisitionTelemetrySelectorComponent.jsx';
import AcquisitionTelemetryChartComponent
  from './../Components/AcquisitionTelemetryChartComponent.jsx';
import SearchComponent from '../Components/SearchComponent';
import AcquisitionTelemetryDateComponent
  from './../Components/AcquisitionTelemetryDateComponent.jsx';
import {
  Col,
  ControlLabel,
  Button
} from 'react-bootstrap';

export class AcquisitionTelemetryContainer extends Component {

  constructor(props) {
    super(props);
    this.state = { hasChanged: false };
  }

  static propTypes= {
    exceptions: PropTypes.array,
    deviceType: PropTypes.string,
    imageType: PropTypes.string,
    searchTerm: PropTypes.string,
    date: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
    onChangeDeviceType: PropTypes.func.isRequired,
    onChangeImageType: PropTypes.func.isRequired,
    onChangeSearchTerm: PropTypes.func.isRequired,
    onChangeDate: PropTypes.func.isRequired
  };

  componentWillReceiveProps(newProps) {
    if (newProps.exceptions !== this.props.exceptions) {
      this.setState({ hasChanged : true });
    }
    else {
      this.setState({ hasChanged : false });
    }
  }

  render() {
    const deviceTypes = ['Android', 'iOS', 'Physical Disk'];
    const imageTypes = ['Physical', 'Quick'];
    return (
      <div>
        <div>
          <AcquisitionTelemetryDateComponent
            date = {this.props.date}
            onChange = {this.props.onChangeDate}
          />
          <AcquisitionTelemetrySelectorComponent
            options = {deviceTypes}
            label = "Filter by Device Type"
            deviceType = {this.props.deviceType}
            onChange = {this.props.onChangeDeviceType}
          />
          <AcquisitionTelemetrySelectorComponent
            options = {imageTypes}
            label = "Filter by Image Type"
            imageType = {this.props.imageType}
            onChange = {this.props.onChangeImageType}
          />
          <SearchComponent
            searchTerm = {this.props.searchTerm}
            onChange = {this.props.onChangeSearchTerm}
            id = "telemetry-search-form"
            label = "Filter by Key Word (case sensitive)"
          />
          <Col md={2}>
            <div>
              <ControlLabel>&nbsp;</ControlLabel>
              <Button className="form-control"
                type="submit"
                onClick={() => this.props.onSubmit(
                  this.props.date,
                  this.props.deviceType,
                  this.props.imageType,
                  this.props.searchTerm)}
              >
                Filter
              </Button>
            </div>
          </Col>
        </div>
        {this.state.hasChanged && <div>
          <AcquisitionTelemetryChartComponent
            exceptions = {this.props.exceptions}
          />
        </div>}
      </div>
    );
  }
}

export const mapDispatchToProps = (dispatch) => ({
  onSubmit: (date, deviceType, imageType, searchTerm) => {
    dispatch(getExceptionsBySearch(
      date, deviceType, imageType, searchTerm));
  },
  onChangeDeviceType: (deviceType) => {
    dispatch(setTelemetryDeviceType(Object.values(deviceType)[0]));
  },
  onChangeImageType: (imageType) => {
    dispatch(setTelemetryImageType(Object.values(imageType)[0]));
  },
  onChangeSearchTerm: (searchTerm) => {
    dispatch(setTelemetrySearchTerm(Object.values(searchTerm)[0]));
  },
  onChangeDate: (date) => {
    const dateString = Object.values(date)[0].format('YYYY.MM.DD');
    dispatch(setTelemetryDate(dateString));
  }
});

export const mapStateToProps = (state) => {
  const exceptions = getExceptionsByTerm(state);
  const deviceType = getAcquireDeviceType(state);
  const imageType = getAcquireImageType(state);
  const searchTerm = getAcquireSearchTerm(state);
  const date = getAcquireDate(state);
  return {
    exceptions : exceptions,
    deviceType : deviceType,
    imageType : imageType,
    searchTerm : searchTerm,
    date : date
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AcquisitionTelemetryContainer);




// WEBPACK FOOTER //
// src/Containers/AcquisitionTelemetryContainer.jsx